export const INSTAGRAM_BOOKINGS_ENTRY_SOURCE_KEY = 'entry_source'

export const INSTAGRAM_BOOKINGS_ENTRY_POINTS = {
  IN_APP_NOTIFICATION: 'target_type',
  DEEPLINK: 'deeplink',
  ONLINE_BOOKING: 'online_booking',
}
